import React from 'react'
//Helpers
import { Col, Container, Row } from 'react-bootstrap'
import useQueryProperty from '@hooks/useQueryProperty'
import {
  getAge,
  getBathrooms,
  getEnvironment,
  getOperations,
  getOrientation,
  getPrices,
  getRooms,
  getSurfaces,
  getType,
} from '@helpers/helper.properties'
import { RealEstateDataPageComponentData } from 'types'

const AboutProperty_1 = ({
  propertyID,
  global_data,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  const icons_style: string = global_data.pageConfig.design.icons

  const icons =
    icons_style === 'Solid' || icons_style === 'Light' ? `-${icons_style.toLowerCase()}` : ''

  return (
    <section className={'property-amenities p-y-config b ' + (isLoading ? 'skeleton' : '')}>
      <Container fluid>
        <Row className="no-gutters justify-content-between">
          <Col
            lg={3}
            className="border-right-color pe-lg-6 px-0 px-lg-3"
          >
            <div className="d-lg-flex justify-content-around with-border-mobile justify-content-lg-between mb-5 mb-lg-0 text-center text-lg-start">
              <div className="div operation-type d-flex justify-content-around flex-row flex-lg-column align-items-center align-items-lg-start">
                <span>{getOperations(allPropertyData)}</span>
                <span className="type">{getType(allPropertyData)}</span>
              </div>
              <div className="price-property d-lg-flex d-none flex-column">
                <i className={'icon-oper-type' + icons}></i>
                <span className="text-uppercase">Valor</span>
                <p>{`${getPrices(allPropertyData)?.at(0)?.currency} ${getPrices(
                  allPropertyData,
                )?.at(0)?.price} `}</p>
              </div>
            </div>
          </Col>
          <Col
            lg={9}
            className="ps-lg-6"
          >
            <Row className="px-0 no-gutters justify-content-lg-between justify-content-center">
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="price-property d-lg-none d-flex flex-column">
                  <i className={'icon-oper-type' + icons}></i>
                  <span className="text-uppercase">Valor</span>
                  <p>{`${getPrices(allPropertyData)?.at(0)?.currency} ${getPrices(
                    allPropertyData,
                  )?.at(0)?.price} `}</p>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-prop-type' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Ambientes</span>
                    <p>{getEnvironment(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-rooms' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Dormitorios</span>
                    <p>{getRooms(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-bathroom' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Baños</span>
                    <p>{getBathrooms(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-measure' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">m² totales</span>
                    <p>{getSurfaces(allPropertyData).total_surface}</p>
                  </div>
                </div>
              </Col>
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-measure' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">m² cubiertas</span>
                    <p>{getSurfaces(allPropertyData).roofed}</p>
                  </div>
                </div>
              </Col>
              {getOrientation(allPropertyData) && (
                <Col
                  xs={6}
                  lg={'auto'}
                  className="text-center text-lg-start"
                >
                  <div className="item-amenities">
                    <i className={'icon-orientation' + icons}></i>
                    <div className="d-flex flex-column">
                      <span className="text-uppercase">Orientación</span>
                      <p>{getOrientation(allPropertyData)}</p>
                    </div>
                  </div>
                </Col>
              )}
              <Col
                xs={6}
                lg={'auto'}
                className="text-center text-lg-start"
              >
                <div className="item-amenities">
                  <i className={'icon-age' + icons}></i>
                  <div className="d-flex flex-column">
                    <span className="text-uppercase">Antigüedad </span>
                    <p>{getAge(allPropertyData)}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutProperty_1
